module.exports = __webpack_public_path__ + "img/felec-m.b6a73de5.jpg";